module.exports = __webpack_public_path__ + "media/images/mobile-resized-10d0ee8de2c8a3a6b22d1f998c1e2fca.png";